import { FC, ReactNode } from 'react'
import {
  StyleCard,
  StyleCardBody,
  StyleCardHeader,
  StyleCardTitle,
} from './style'
interface SettingCardProps {
  children: ReactNode
  title: string
}
const SettingCard: FC<SettingCardProps> = ({ children, title }) => {
  return (
    <StyleCard>
      <StyleCardHeader>
        <StyleCardTitle>{title}</StyleCardTitle>
      </StyleCardHeader>
      <StyleCardBody>{children}</StyleCardBody>
    </StyleCard>
  )
}

export default SettingCard
